import { useState } from "react";
import {
  MotionBox as Box,
  MotionGrid as Grid,
  viewAppearDefault,
  staggeredAppear,
} from "utils/motion";
import { useCookie } from "utils/cookieHelper";
import {
  tagEventForm,
  persistRegistrationCookies,
  getRegistrationData,
} from "utils/formHelper";
import Trans from "components/base/Trans";
import Container from "components/base/Container";
import ModalSchedule from "components/sections/ModalSchedule";
import FormRegister from "components/blocks/FormRegister";
import ScheduleInfo from "components/blocks/ScheduleInfo";

const ScheduleSection = (props) => {
  const cookie = useCookie(props.cookie);
  const [isModalScheduleOpen, setModalScheduleOpen] = useState(false);
  const [scheduleData, setScheduleData] = useState({});
  const { title, description, descriptionContent, extraValues, model, pt } =
    props;

  const registerSuccess = (values, res) => {
    tagEventForm(values.email, values.phone, values.name, res?.pid || null, [
      "Lead",
    ]);
    persistRegistrationCookies(cookie, values, res);
    setScheduleData(getRegistrationData(values, res));
    setModalScheduleOpen(true);
  };

  return (
    <>
      <Box id="presentation" maxWidth="100%" bg="black.900" color="white">
        <Box px={[0, null, 16]}>
          <Container
            id="register"
            position="relative"
            height="100%"
            maxWidth="xl"
            display="flex"
            alignItems="center"
            px={[6, 6, 0]}
            pt={pt || [16, null, 40]}
          >
            <Grid
              width="100%"
              templateColumns={[
                "1fr",
                "1fr",
                null,
                descriptionContent ? "1fr" : "1fr 1.25fr",
                descriptionContent ? "1fr" : "1.25fr 1fr",
                null,
              ]}
              gap={16}
              py={16}
              alignItems="start"
              justifyItems={
                descriptionContent
                  ? "center"
                  : ["center", "center", null, "end"]
              }
              variants={staggeredAppear}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <Box variants={viewAppearDefault}>
                <ScheduleInfo
                  title={title}
                  description={description}
                  descriptionContent={descriptionContent}
                  model={model}
                />
              </Box>
              <Box variants={viewAppearDefault}>
                <FormRegister
                  onSuccess={registerSuccess}
                  buttonText={props.cta || <Trans id="LBL_FORM_REGISTER_CTA" />}
                  extraValues={extraValues}
                  needAdditionalCheck
                  center={!!descriptionContent}
                  model={model}
                />
              </Box>
            </Grid>
          </Container>
        </Box>
      </Box>
      <ModalSchedule
        isOpen={isModalScheduleOpen}
        onClose={() => setModalScheduleOpen(false)}
        data={scheduleData}
        cookie={props.cookie}
        idRef={props.idRef}
      />
    </>
  );
};

export default ScheduleSection;
